import { Link } from 'react-router';
import { getJobNotificationUrl } from '@utils/notifications';

/**
 * Component to display a link to a project or model.
 *
 * @param {string} project_uuid - The UUID of the project.
 * @param {string} project_title - The title of the project. Defaults to 'Unknown Project' if not provided.
 * @param {string} model_uuid - The UUID of the model. Used as the `?model=` query parameter for model-mode runs.
 * @param {string} collection_uuid - The UUID of the collection a detection ran for. When set, the link targets the collection-based (v2) route with `?collection_uuid=`.
 * @param {string} jobType - The type of job. If 'model_evaluation' or 'user_annotation_train', the URL will point to the model page.
 * @returns {JSX.Element|null} The project link or null if no project UUID is provided.
 */
const NotificationLink = ({
	project_uuid,
	project_title,
	project_mode,
	model_uuid,
	collection_uuid,
	model_info,
	jobType,
	disabled,
}) => {
	const modelEvaluationJob = jobType === 'model_evaluation';

	const createTitle = () => {
		if (modelEvaluationJob) return model_info?.[0]?.class_name || 'Model Evaluation';

		return project_title || 'Unknown Project';
	};

	const title = createTitle();
	const url = getJobNotificationUrl({
		project_uuid,
		project_mode,
		model_uuid,
		collection_uuid,
		jobType,
	});

	if (disabled && !modelEvaluationJob) return <p className="mb-0">{title}</p>;
	return (
		<Link to={url} reloadDocument className="inherit">
			{title}
		</Link>
	);
};
export default NotificationLink;
